import React, { useState, useMemo, useContext } from 'react';
import { Link, NavLink, useMatch } from "react-router-dom";
import Dropzone from 'react-dropzone'
import { Button } from 'primereact/button';


const UploadComponent = (props) => {
    const [displayItems, setDisplayItems] = useState([]);
   const acceptedFiles = [];
   const label = props.label;
   const acceptedType = props.acceptedType;

   const onChangeSample = (acceptedFiles)=>{
    console.log(acceptedFiles);
    props.callBackFunction(acceptedFiles);
   }

   const rejectedFiles = (reject) =>{
    console.log(reject);
   }

    return (
        <div className="row">
            <Dropzone onDrop={(acceptedFiles) => onChangeSample(acceptedFiles)} multiple={true} accept={acceptedType} onDropRejected={(Files) => rejectedFiles(Files)} onError={(Files) => rejectedFiles(Files)}>
                {({ getRootProps, getInputProps }) => (
                    <section>
                        <div {...getRootProps({ className: 'dropzone bg-light' })}>
                            <input {...getInputProps()} />
                            <Button label='Browse' outlined size="small" className='mb-2'></Button>
                            <span className='mb-1'>OR</span>
                            <span>{label}</span>
                        </div>
                    </section>
                )}
            </Dropzone>
        </div>
    );
}

export default UploadComponent;

